import BaseFormView from "scripts/views/baseFormView";
import VerifyEmailNotificationModel from "scripts/models/verifyEmailNotificationModel";

import verifyEmailNotificationForm from "templates/verifyEmailNotificationForm.hbs";

class VerifyEmailNotificationFormView extends BaseFormView {
  get template() {
    return verifyEmailNotificationForm;
  }

  get events() {
    return {
      "submit form": "onSubmit",
    };
  }

  initialize(options) {
    this.bindModel(
      new VerifyEmailNotificationModel({
        targetUrl: `${window.location.origin}/verify-email`,
        emailAddress: options && options.emailAddress,
      }),
    );
  }

  render() {
    this.$el.html(this.template(this.model.attributes));

    return this;
  }
}

export default VerifyEmailNotificationFormView;
